import { markUploadsComplete, resolveTemplateFiles } from "../pipeline";

// Document style templates are not backed by a processing flow: the initialize
// response is the list of created FileUpload rows for local files only (SharePoint
// templates are already saved server-side by then), so completion is marked
// directly once the chunks upload — no SSE handover.
export const createTemplateStrategy = (config) => ({
  uploadUrl: config.uploadUrl,
  usesFlow: false,

  prepareFiles: ({ selectedFiles }) => selectedFiles,
  buildBaseInfo: () => ({}),
  getFields: () => ({}),
  beforeInitialize: async () => {},

  resolveDirectResponse: resolveTemplateFiles,

  afterUpload: ({ displayedFiles, dispatch }) =>
    markUploadsComplete({ dispatch, files: displayedFiles }),
});
